module.exports = __webpack_public_path__ + "images/Correct_loop.gif";